import type { Template } from "@/types";

export const LA_06_H6_V0: Template[] = [
    {
        id: "la-06-h6v0-01",
        name: "LA 01 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 37, width: 440, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 306, width: 217, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 306, width: 216, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 37, width: 440, height: 262, rotation: 0, imageRotation: 0 },
            { id: "5", x: 803, y: 306, width: 217, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 306, width: 216, height: 140, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-02",
        name: "LA 02 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 37, width: 440, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 306, width: 217, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 306, width: 216, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 184, width: 440, height: 262, rotation: 0, imageRotation: 0 },
            { id: "5", x: 803, y: 37, width: 217, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 37, width: 216, height: 140, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-03",
        name: "LA 03 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 206, y: 0, width: 264, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 206, y: 164, width: 264, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 206, y: 328, width: 264, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 882, y: 0, width: 264, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 164, width: 264, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 882, y: 328, width: 264, height: 155, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-04",
        name: "LA 04 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_04.png",
        size: [1352, 483],
        style: {},
        slots: [         
            { id: "1", x: 38, y: 23, width: 338, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 245, width: 338, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 23, width: 704, height: 435, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1095, y: 23, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1095, y: 171, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1095, y: 319, width: 220, height: 139, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-05",
        name: "LA 05 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_05.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 38, y: 23, width: 338, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 245, width: 338, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 23, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 171, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 383, y: 319, width: 220, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 610, y: 23, width: 704, height: 435, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-06",
        name: "LA 06 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_06.png",
        size: [1352, 483],
        style: {},
        slots: [         
            { id: "1", x: 38, y: 24, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 172, width: 220, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 38, y: 320, width: 220, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 24, width: 338, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 265, y: 246, width: 338, height: 213, rotation: 0, imageRotation: 0 },
            { id: "6", x: 610, y: 24, width: 704, height: 435, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-07",
        name: "LA 07 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_07.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 103, y: 44, width: 318, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 246, width: 318, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 44, width: 618, height: 395, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1054, y: 44, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1054, y: 179, width: 195, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1054, y: 313, width: 195, height: 126, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-08",
        name: "LA 08 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 94, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 246, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 229, y: 94, width: 443, height: 296, rotation: 0, imageRotation: 0 },       
            { id: "4", x: 680, y: 94, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 680, y: 246, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 94, width: 443, height: 296, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-09",
        name: "LA 09 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 94, width: 443, height: 296, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 451, y: 94, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 246, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 94, width: 221, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 246, width: 221, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 94, width: 443, height: 296, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-10",
        name: "LA 10 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h6_v0_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 93, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 245, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 93, width: 442, height: 296, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 93, width: 442, height: 296, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 93, width: 222, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 245, width: 222, height: 144, rotation: 0, imageRotation: 0 }
        ],
    }
];